import { render, staticRenderFns } from "./EditUserRolesCard.vue?vue&type=template&id=85e838be&"
import script from "./EditUserRolesCard.vue?vue&type=script&lang=js&"
export * from "./EditUserRolesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports